import { render, staticRenderFns } from "./listItemNew.vue?vue&type=template&id=445a38d8&scoped=true"
import script from "./listItemNew.vue?vue&type=script&lang=js"
export * from "./listItemNew.vue?vue&type=script&lang=js"
import style0 from "./listItemNew.vue?vue&type=style&index=0&id=445a38d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445a38d8",
  null
  
)

export default component.exports